import type { Theme } from '@mui/material';

export const styles = {
  tooltip: (theme: Theme) => ({
    width: '30rem',
    bgcolor: theme.colors.white,
    border: `1px solid ${theme.colors.neutral[800]}`,
    borderRadius: '0.5rem',
    overflow: 'hidden',
    maxWidth: '95vw',
  }),

  headline: (theme: Theme) => ({
    p: '0.5rem 1.5rem',
    bgcolor: theme.colors.neutral[800],
    color: theme.colors.white,
    justifyContent: 'space-between',
  }),

  langSwitcher: {
    marginRight: '0.75rem',
  },

  image: {
    '> img': {
      width: '100%',
      height: 'auto',
    },
  },

  body: {
    p: '1.5rem',
  },

  content: {
    maxHeight: '8rem',
    overflowY: 'auto',
    whiteSpace: 'pre-line',
  },

  closeButton: (theme: Theme) => ({
    color: theme.colors.white,
    p: 0,
    mr: '-0.25rem', // for a better alignment of the icon
  }),

  divider: (theme: Theme) => ({
    borderColor: theme.colors.neutral[100],
  }),

  stepCounter: {
    flexGrow: 1,
    justifyContent: 'space-between',
    margin: 'auto 0',
  },

  stepDot:
    (isActive = false) =>
    (theme: Theme) => ({
      borderRadius: '50%',
      width: '1.25rem',
      height: '1.25rem',
      bgcolor: theme.colors.primary[isActive ? 500 : 50],
    }),
};
